<template>
  <fieldset>
    <div class="form-wrap">

      <div>
        <label for="name">Company Name</label>
        <input type="text" id="name" v-model="$parent.affiliate.name" required>
      </div>

      <div>
        <label for="code">Affiliate Code</label>
        <input id="code" type="text" v-model="$parent.affiliate.code" required>
      </div>

      <div>
        <label for="email">Email Address</label>
        <input id="email" type="email" v-model="$parent.affiliate.email">
      </div>

      <div>
        <label for="phone">Phone Number</label>
        <input type="text" id="phone" v-model="$parent.affiliate.phone_number">
      </div>

     <div>
        <label for="address_line_1">Address Line 1</label>
        <input type="text" id="address_line_1" v-model="$parent.affiliate.address_line_1">
      </div>

     <div>
        <label for="address_line_2">Address Line 2</label>
        <input type="text" id="address_line_2" v-model="$parent.affiliate.address_line_2">
      </div>

     <div>
        <label for="town_city">Town/City</label>
        <input type="text" id="town_city" v-model="$parent.affiliate.town_city">
      </div>

     <div>
        <label for="county">County</label>
        <input type="text" id="county" v-model="$parent.affiliate.county">
      </div>

     <div>
        <label for="postcode">Postcode</label>
        <input type="text" id="postcode" v-model="$parent.affiliate.postcode">
      </div>

      <div>
          <label for="email">Artwork Email address</label>
          <input id="email" type="email" placeholder="Artwork Email address" v-model="$parent.affiliate.artwork_email">
      </div>

      <div>
        <label for="commission">Commission (%)</label>
        <input type="number" id="commission" v-model="$parent.affiliate.commission">
      </div>

      <div>
        <label for="status">Is Active</label>
        <label class="switch">
          <input id="is-active" type="checkbox" v-model="$parent.affiliate.is_active">
          <span class="switch__slider"></span>
        </label>
      </div>

    </div>
  </fieldset>
</template>

<script>
export default {
  name: 'AffiliateFields',
  data () {
    return {
      loading: false
    }
  }
}
</script>
